import { DirectionPage, MetaData, SubDirectionPage, TextPage } from '@/components'

export default function NextTypePage(props) {
  const { type, data } = props;
  const { title, description } = data.meta;

  switch (type) {
    case 'direction':
      return (
        <>
          <MetaData title={title || data.title} description={description}/>
          <DirectionPage {...data} />
        </>
      )
    case 'subdirection':
      return (
        <>
          <MetaData title={title || data.title} description={description}/>
          <SubDirectionPage {...data} />
        </>
      )
    case 'text_page':
      return (
        <>
          <MetaData title={title || data.title} description={description}/>
          <TextPage {...data} />
        </>
      )
  }
}

NextTypePage.getInitialProps = async ({ query, api }) => {
  const { typeSlug, ...otherQueries } = query

  const response = await api.type({ slug: typeSlug, ...otherQueries })

  const { page_type: type, data } = response

  return { type, data }
}
